export default __webpack_public_path__ + "static/media/NancyClavijo.7e33426d.jpeg";